export const color = {
  grey: {
    50: '#FBFBFB',
    100: '#F7F7F7',
    200: '#EEEEEE',
    300: '#E3E3E3',
    400: '#D0D1D1',
    500: '#B0B3B3',
    600: '#8E9293',
    700: '#5D6365',
    800: '#343C3E',
    900: '#010B0E'
  },
  primary: {
    50: '#E7ECF1',
    100: '#DCE4ED',
    200: '#CAD8E6',
    300: '#ACC4DB',
    400: '#8AADCE',
    500: '#6594C0',
    600: '#417BB2',
    700: '#135CA1',
    800: '#084A89',
    900: '#013363'
  },
  success: {
    50: '#EFFCEE',
    100: '#E5FAE3',
    200: '#D3F6D0',
    300: '#B5F0B0',
    400: '#84E67C',
    500: '#50DB44',
    600: '#30BD23',
    700: '#1B9C10',
    800: '#0D7604',
    900: '#0A6402'
  },
  error: {
    50: '#FFF0EF',
    100: '#FFD9D8',
    200: '#FFCCCA',
    300: '#FDA7A3',
    400: '#F37772',
    500: '#DE4C45',
    600: '#C2241D',
    700: '#A50B04',
    800: '#8B0A04',
    900: '#5E0501'
  },
  warning: {
    50: '#F8EFE8',
    100: '#F8E9DE',
    200: '#F8E0CE',
    300: '#F8D1B3',
    400: '#F9B786',
    500: '#FB8C3C',
    600: '#DF6F1E',
    700: '#C2590C',
    800: '#A94903',
    900: '#8B3A00'
  },
  secondary: {
    dark: {
      50: '#F1F2F3',
      100: '#EDEFF0',
      200: '#E7EAEC',
      300: '#DDE1E4',
      400: '#CCD2D7',
      500: '#AFB9C2',
      600: '#7F8F9E',
      700: '#617588',
      800: '#3C556C',
      900: '#0D2C49',
      950: '#0B2843'
    },
    light: {
      50: '#F2F4F4',
      100: '#EAEEEE',
      200: '#E2E8E7',
      300: '#D9E1E1',
      400: '#D0D8D7',
      500: '#BECAC9',
      600: '#9FB0AF',
      700: '#7A9795',
      800: '#456F6C',
      900: '#1E4542'
    }
  },

  black: '#000000',
  white: '#FFFFFF'
}
